import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess} from '@/utils/notification';
import {
  SYSTEM_CONFIG_WESTERN,
  SYSTEM_CONFIG_NATION,
  SYSTEM_CONFIG_DEMO,
  SYSTEM_CONFIG,
  ADD_SYSTEM_CONFIG,
  UPDATE_SYSTEM_CONFIG,
} from '@/queries/modules/system/system-config';
import {resolveTenantFromUrl, TENANT_NATION} from '@/utils/tenant';

export async function getSystemConfigWestern(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: SYSTEM_CONFIG_WESTERN,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.systemConfigWestern
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getSystemConfigNation(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: SYSTEM_CONFIG_NATION,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.systemConfigNation
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getSystemConfigDemo(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: SYSTEM_CONFIG_DEMO,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.systemConfigDemo
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getSystemConfig(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: SYSTEM_CONFIG,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.systemConfig
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addSystemConfig(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_SYSTEM_CONFIG,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', newItemSuccess(data.addSystemConfig.nameLocal));

      return data.addSystemConfig
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateSystemConfig(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_SYSTEM_CONFIG,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      context.commit('setSuccess', updateItemSuccess(data.updateSystemConfig.nameLocal));

      return data.updateSystemConfig
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

// Navbar contact text (layouts/components/navbar/components/ContactInfo.vue).
// Picks the tenant query the same way Login.vue does and loads once per page
// load. Any failure -- an action returning null, a throw, a missing field --
// settles to '' so the navbar just shows nothing.
//
// Unlike Login.vue (which only ever evaluates /user/login URLs), the navbar
// runs on whatever page loads first -- and a route path can itself contain
// "nation" (e.g. the teacher /examination route) or "western" by accident.
// So when no url is passed, resolve against the hostname + query string only,
// never the path. An explicit url argument (tests, callers that pass one)
// still goes through unchanged.
export async function loadContactInfo(context, url) {
  if (context.state.contactInfoLoaded) return context.state.contactInfo;

  let text = '';
  try {
    const defaultUrl = window.location.hostname + window.location.search;
    const tenant = resolveTenantFromUrl(url || defaultUrl);
    const config = await context.dispatch(
      tenant === TENANT_NATION ? 'getSystemConfigNation' : 'getSystemConfigWestern'
    );
    if (config && typeof config.contactInfo === 'string') {
      text = config.contactInfo.trim();
    }
  } catch (e) {
    text = '';
  }

  context.commit('setContactInfo', text);
  return text;
}
